@use "../../styles/layout.module.scss" as l;
@use "../../styles/breakpoint.module.scss" as *;

.fullWidth {
    display: grid;
    grid-template-columns: subgrid;
    grid-column: 1 / -1;
}

.root {
    composes: fullWidth;
    position: relative;
}

.carousel {
    composes: fullWidth;
    row-gap: var(--spacer-24);
}

.viewport {
    grid-column: 1 / -1;
    grid-row: 2;
    overflow: hidden;
}

.container {
    display: flex;
    align-items: stretch;
}

.slide {
    flex: 0 0 l.span(8);
    padding-left: calc(var(--spacer-gutter) / 2);
    padding-right: calc(var(--spacer-gutter) / 2);

    @media ($below-tablet) {
        flex: 0 0 l.span(10);
    }

    @media ($below-mobile) {
        flex: 0 0 l.span(6);
    }
}

.controls {
    display: flex;
    grid-row: 3;
    grid-column: 1 / col-end 12;
    justify-content: end;
    gap: 7px;

    > :first-child {
        transform: rotate(180deg);
    }

    @media ($below-tablet) {
        display: none;
    }
}

.dotsWrapper {
    composes: dotsWrapper from "../Clickables/dots.module.scss";
    grid-row: 3;
}

.dot {
    composes: dot from "../Clickables/dots.module.scss";
}

.card {
    padding: var(--spacer-80) var(--spacer-64);
    height: 100%;
    background-color: var(--color-primary);

    @media ($below-tablet) {
        padding: var(--spacer-40) var(--spacer-40);
    }

    @media ($below-mobile) {
        padding: var(--spacer-48) var(--spacer-40);
    }
}

.cardRounded {
    border-radius: var(--border-radius-lg) var(--border-radius-lg)
        var(--border-radius-lg) 0;
}

.cardInner {
    display: flex;
    flex-direction: column;
    height: 100%;
    gap: var(--spacer-24);
}

.quote {
    flex: 1;
    margin: 0;
}

.quoteText {
    composes: fontSH32 from "../../styles/typography.module.scss";
    color: var(--color-text);
    margin: 0;
    position: relative;
}

.openQuote {
    position: absolute;
    left: -0.35em;
}

.attribution {
    display: flex;
    align-items: flex-start;
    gap: var(--spacer-16);
    min-height: 80px;

    @media ($below-mobile) {
        flex-direction: column-reverse;
        align-items: flex-start;
        gap: var(--spacer-16);
        // Always reserve space for the image area.
        // This way the name text sits at the same vertical position across all cards,
        // regardless of whether an image is present or what type it is.
        padding-bottom: calc(64px + var(--spacer-16));
    }
}

.attributionText {
    flex: 1;
}

.name {
    composes: fontB16 from "../../styles/typography.module.scss";
    color: var(--color-text);
    margin: 0 0 var(--spacer-4) 0;
}

.positionCompany {
    composes: fontST16 from "../../styles/typography.module.scss";
    color: var(--color-text);
    margin: 0 0 var(--spacer-8) 0;
}

.leanInStatus {
    composes: fontST14 from "../../styles/typography.module.scss";
    color: var(--color-text);
    margin: 0;
}

.image--headshot {
    flex-shrink: 0;
    width: 80px;
    height: 80px;
    border-radius: var(--border-radius-full);
    overflow: hidden;

    @media ($below-mobile) {
        width: 64px;
        height: 64px;
        margin-bottom: calc(-64px - var(--spacer-16));
    }

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
    }
}

.image--logo {
    flex-shrink: 0;
    width: 152px;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;

    @media ($below-mobile) {
        width: 114px;
        height: 60px;
        margin-bottom: calc(-60px - var(--spacer-16));
    }

    img {
        max-width: 100%;
        max-height: 100%;
        object-fit: contain;
        display: block;
    }
}
